import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { PurgeSettings } from 'types';

export const getPurgeSettings = async (): Promise<PurgeSettings> => {
  const { data }: { data: PurgeSettings } = await axios.get(`/api/purge`);
  return data as PurgeSettings;
};

type QueryFnType = typeof getPurgeSettings;

type UsePurgeSettingsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const usePurgeSettings = ({ config }: UsePurgeSettingsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['purgeSettings'],
    queryFn: () => getPurgeSettings(),
    ...config,
  });
};
